import { render, staticRenderFns } from "./FaizTuruList.vue?vue&type=template&id=7c743678"
import script from "./FaizTuruList.vue?vue&type=script&lang=ts"
export * from "./FaizTuruList.vue?vue&type=script&lang=ts"
import style0 from "./FaizTuruList.vue?vue&type=style&index=0&id=7c743678&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports